import type { FilterGroupItem, FilterItem, FilterLineItem, FilterOperator } from './filterSettings';

export function createFilterLine(columnId: string, operator: string, value: string): FilterLineItem {
  return {
    type: 'line',
    id: `line-${Date.now()}-${Math.random()}`,
    operator: 'and',
    filterType: { id: columnId, label: columnId },
    operatorType: { id: operator, label: operator },
    value,
  };
}

export function createFilterGroup(
  items: FilterItem[],
  options: {
    operator: FilterOperator;
  } = { operator: 'and' },
): FilterGroupItem {
  return {
    type: 'group',
    id: 'root',
    operator: options.operator,
    items,
  };
}
